<template>
    <div id="step">
        <section>
            <h3>
            Conditions Générales d’Utilisation de l’Application Mobile NSIA DIRECT
            </h3>
            <h3>ARTICLE 1 : INTRODUCTION</h3>
                <p>
                La société́ NSIA Assurances, compagnie d’assurances agrée suivant le code
                CIMA des Assurances, exploite l’Application Mobile « NSIA Direct »
                ci-après dénommée « l’Application Mobile » ou « le Service » ;
                </p>
                <p>
                Le directeur de la publication du Service est Monsieur DJEKET Yao Constant
                L’adresse électronique du contact est :
                <a href="mailto:nsiadirect.tg@groupensia.com"
                    >nsiadirect.tg@groupensia.com</a
                >
                </p>
        </section>
        <section id="article_2">
            <h3>ARTICLE 2 : OBJET ET CHAMP D’APPLICATION DES CGU</h3>
            <p>
            Les présentes Conditions Générales d’Utilisation décrites ci-après et
            ci-après dénommées « CGU », régissent les rapports entre NSIA DIRECT et
            les Utilisateurs, ci- après dénommés « l’Utilisateur » ou « les
            Utilisateurs » de l’Application Mobile, et s’appliquent sans restriction
            ni réserve pour toute utilisation ou téléchargement de l’Application
            Mobile.
            </p>
            <p>
            L’Utilisateur est tenu d’accepter les présentes CGU pour tout compte et
            pour toute utilisation de l’Application Mobile en cochant la case « Je
            reconnais avoir lu et accepté les Conditions Générales d’Utilisation ».
            </p>
            <p>
            Les présentes CGU sont accessibles à tout moment dans l’Application Mobile
            dans la rubrique « C.G.U » qui se trouve dans le MENU PRINCIPAL et
            prévaudront, le cas échéant, sur toute autre version ou tout autre
            document contradictoire.
            </p>
            <p>
            NSIA Assurances pourra modifier les présentes CGU à tout moment, sans
            préavis. Les Utilisateurs seront informés de la modification des présentes
            par le biais de la publication des CGU actualisées sur l’application et
            par une notification signalant ce changement au sein de l’application. Les
            CGU modifiées prendront effet à partir de leur publication. La poursuite
            de l’utilisation du Service suite à cette publication constituera une
            acceptation de la nouvelle version des présentes.
            </p>
            <p>
            L’Hébergeur de l’Application Mobile est e-BA, E-BUSINESS AFRIQUE, SARL au
            capital de 1 000 000 FCFA, sise à Adidogomé-Lomé derrière les Frères
            Franciscains, 04BP417, Tél :
            <a href="tel:+22822500812">(00228) 22 50 08 12</a> /
            <a href="tel:+22892009293">92 00 92 93</a> /
            <a href="tel:+22898413434">98 41 34 34</a>, Site web:
            <a href="https://www.ebusinessafrique.com" target="_blank"
                >www.ebusinessafrique.com</a
            >,
            </p>
            <p>
            Il est donc conseillé aux Utilisateurs de lire très attentivement les
            présentes CGU et de consulter régulièrement les CGU mises à jour, dans la
            Rubrique « C.G.U » de l’Application Mobile ou sur l’onglet « Conditions
            générales d’utilisation » du site NSIA DIRECT (<a
                href="https://nsiadirect.tg"
                target="_blank"
                >nsiadirect.tg</a
            >).
            </p>
            <p>
            Dans le cas où un Utilisateur n’accepterait pas les présentes CGU ou
            refuserait de s’y conformer, il ne doit pas utiliser l’Application Mobile.
            Dans ce cas, il est recommandé́ de désinstaller l’Application Mobile. En
            procédant à son Inscription, l’Utilisateur confirme avoir pris
            connaissance des présentes CGU et accepte de s'y soumettre sans réserve.
            </p>
            <p>
            Sauf preuve contraire, les données enregistrées dans le système
            informatique de l’Application Mobile constituent la preuve de l’ensemble
            des transactions conclues avec les Utilisateurs.
            </p>
        </section>
        <section id="article_3">
            <h3>ARTICLE 3 : PRÉSENTATION GÉNÉRALE DU SERVICE</h3>
            <h5>3.1 Objet du Service</h5>
            <p>
            Le Service est une application de mise à disposition des produits
            d’assurance NSIA à l’attention du public.
            </p>
            <h5>3.2 Fonctionnement du Service</h5>
            <p>
            L’Application Mobile NSIA Direct peut être téléchargée via les boutiques
            d’applications mobiles (telles que notamment Google Play ou l’App Store)
            au moyen des technologies disponibles, et notamment d'un terminal mobile
            de type smartphone.
            </p>
            <p>
            Pour bénéficier du Service, l’Utilisateur doit donc disposer d’un
            smartphone, d’un accès internet et d’un Compte personnel d’Utilisateur
            (cf. Article 4).
            </p>
            <p>
            Le Service se présente essentiellement sous la forme d’un défilé de
            produits et services accessibles aux utilisateurs.
            </p>
            <p>
            Les fonctionnalités de l’Application Mobile NSIA Direct sont les suivantes
            :
            </p>
            <ul>
            <li>
                L’Utilisateur renseigne les informations nécessaires pour la création
                d’un Compte personnel d’Utilisateur conformément à l’article 4 ;
            </li>
            <li>
                L’Utilisateur voit s’afficher les produits et services disponibles ;
            </li>
            <li>
                L’Utilisateur a la possibilité de souscrire à des produits et services
                et en négocier la prime à payer ;
            </li>
            <li>
                L’Utilisateur a la possibilité de passer au paiement de sa prime via les
                moyens de paiement disponibles et annoncés sur l’application ;
            </li>
            <li>
                L’Utilisateur peut envoyer des suggestions ou discuter avec des
                gestionnaires commerciaux ;
            </li>
            <li>
                L’Utilisateur peut potentiellement prendre part à des jeux et bénéficier
                de promotions et de goodies en utilisant l’Application Mobile pour
                souscrire à ses assurances.
            </li>
            <li>
                L’Utilisateur voit s’afficher les produits et services disponibles ;
            </li>
            <li>
                L’Utilisateur a la possibilité de souscrire à des produits et services
                et en négocier la prime à payer ;
            </li>
            <li>
                L’Utilisateur a la possibilité de passer au paiement de sa prime via les
                moyens de paiement disponibles et annoncés sur l’application ;
            </li>
            <li>
                L’Utilisateur peut envoyer des suggestions ou discuter avec des
                gestionnaires commerciaux ;
            </li>
            <li>
                L’Utilisateur peut potentiellement prendre part à des jeux et bénéficier
                de promotions et de goodies en utilisant l’Application Mobile pour
                souscrire à ses assurances.
            </li>
            </ul>
        </section>
        <section id="article_4">
            <h3>ARTICLE 4 : CRÉATION D’UN COMPTE PERSONNEL D’UTILISATEUR</h3>
            <p>
            Pour accéder au Service, tout Utilisateur doit préalablement procéder à
            son Inscription en créant un Compte personnel d’Utilisateur.
            </p>
            <p>
            Afin de créer un Compte personnel d’Utilisateur, l’Utilisateur doit
            s'inscrire en remplissant le formulaire d'inscription au démarrage de
            l’Application Mobile et renseigner les informations suivantes : Prénom,
            Nom de Famille, Adresse, Email, mot de passe choisi (optionnel), numéro de
            téléphone.
            </p>
            <p>
            Les informations qui seront visibles sur le profil de l’Utilisateur sont
            les suivantes :
            </p>
            <ul>
            <li>Prénom,</li>
            <li>Nom de Famille,</li>
            <li>Code postal,</li>
            <li>E-mail</li>
            <li>Numéro de téléphone</li>
            </ul>
            <p>
            La validation du Compte personnel d’Utilisateur est formalisée après
            vérification de son numéro de téléphone (envoi d’un code) par
            l’Utilisateur dans le formulaire d’inscription.
            </p>
            <p>
            En cas d’oubli de mot de passe, il suffit de cliquer sur « mot de passe
            oublié » et l’application envoie à l’adresse e-mail de l’utilisateur un
            lien permettant de le redéfinir.
            </p>
            <p>
            Le renseignement de ces données et la validation du compte personnel sont
            indispensables à la fourniture du Service.
            </p>
            <p>
            L’Utilisateur s’engage à fournir des informations vraies, sincères,
            complètes et toujours à jour.
            </p>
            <p>
            Dans le cas où les informations transmises par L’Utilisateur se
            révèleraient fausses, incomplètes, obsolètes ou ne permettant pas la
            fourniture du Service dans les meilleures conditions, NSIA DIRECT se
            réserve le droit de procéder à la fermeture du Compte personnel de
            l’Utilisateur et ainsi de lui refuser l’accès au Service, sans préavis et
            sans que cela ne lui ouvre un quelconque droit à indemnité́.
            </p>
            <p>
            L’Utilisateur s'engage à ne créer qu'un seul Compte personnel
            correspondant à son identité́.<br />
            L’Utilisateur reste seul responsable de tout usage qui pourrait être fait
            de ses identifiants et mot de passe, et de leur confidentialité́, ainsi que
            de toute utilisation de son Compte personnel.
            </p>
            <p>
            L’Utilisateur s'engage à informer immédiatement NSIA Assurances de toute
            utilisation ou risque d’utilisation frauduleuse de son Compte personnel,
            et de toute atteinte à la confidentialité́ et à la sécurité́ de ses
            identifiants et mot de passe à l’adresse électronique de contact :
            <a href="mailto:ecoute.togo@groupensia.com">ecoute.togo@groupensia.com</a>
            </p>
            <p>
            NSIA DIRECT ne pourra en aucun cas être tenu responsable de toute perte ou
            vol ou tout dommage résultant de la perte ou du vol ou d’une utilisation
            frauduleuse des données d’identifications des Utilisateurs.
            </p>
        </section>
        <section id="article_5">
            <h3>ARTICLE 5 : TARIFS ET MODALITÉS FINANCIERES</h3>
            <p>
            Le téléchargement et l’utilisation de l’Application Mobile NSIA DIRECT
            sont gratuits.
            </p>
            <p>
            L’Application Mobile téléchargée gratuitement permet d’accéder à tous les
            services proposés tels que décrits à l’Article 3 des présentes.
            </p>
        </section>
        <section id="article_6">
            <h3>ARTICLE 6 : OBLIGATIONS DE L’UTILISATEUR</h3>
            <p>
            Le Service NSIA DIRECT a pour finalité de favoriser la souscription aux
            produits d’assurance de NSIA Assurances sans se déplacer. Toute
            utilisation du Service contraire à cette finalité sera contraire aux
            présentes CGU.
            </p>
            <p>
            L’Utilisateur reconnait disposer de la compétence et des moyens techniques
            nécessaires pour télécharger et utiliser l’Application Mobile, le matériel
            utilisé restant exclusivement à sa charge.
            </p>
            <p>
            L’Utilisateur s’engage à communiquer des informations exactes lors de son
            inscription permettant l’accès au Service conformément à l’Article 4 des
            présentes.
            </p>
            <p>
            L’Utilisateur est notamment informé du fait que l’utilisation du Service
            peut nécessiter l’acceptation de la géolocalisation lorsqu’il utilise
            l’Application Mobile pour une bonne utilisation du Service.
            </p>
            <p>
            L’Utilisateur s’engage à faire une utilisation adéquate et licite du
            Service et de ses contenus, conformément à la législation en vigueur, les
            présentes CGU, la morale, les bonnes mœurs et l’ordre public.
            </p>
            <p>
            Les Utilisateurs qui utilisent le Service pour des finalités interdites
            par la Loi et/ou contraires aux présentes seront exposés à des poursuites
            judiciaires et les données permettant leur identification pourront être
            fournies aux autorités compétentes en cas de procédure judiciaire engagée
            contre eux.
            </p>
            <p>
            NSIA DIRECT est un simple outil mettant en relations les Utilisateurs avec
            NSIA Assurances et permettant également aux Utilisateurs d’avoir accès à
            des produits et/ou services commercialisés par NSIA Assurances.
            L’Utilisateur est par conséquent entièrement responsable de l’utilisation
            faite du Service, ainsi que des décisions qu’il pourrait prendre après
            avoir consulté́ les informations contenues dans l’Application Mobile. NSIA
            DIRECT ne peut être tenue pour responsable de tout dommage direct ou
            indirect, de quelque nature que ce soit, causé par une mauvaise
            utilisation ou de l’utilisation illégale ou illicite du Service par un
            Utilisateur, par toute information ou tout autre contenu communiqué,
            transmis ou diffusé par un Utilisateur à l’occasion de l'utilisation du
            Service, ou par tout manquement quelconque de sa part aux présentes CGU.
            </p>
            <p>
            Notamment, sans que cette liste soit limitative, l’Utilisateur est informé
            qu’il lui est formellement interdit :
            </p>
            <ul>
            <li>
                D’entreprendre une utilisation non-autorisée ou frauduleuse de
                l’Application Mobile et/ou de ses contenus à des fins ou effets
                illicites ;
            </li>
            <li>
                D’accéder ou essayer d’accéder à des ressources ou aires restreintes de
                l’Application Mobile, sans respecter les conditions exigées pour cet
                accès ;
            </li>
            <li>
                D’introduire ou de diffuser sur le réseau des virus informatiques ou
                tout autre système physique ou logique qui soient susceptibles de
                provoquer des dommages sur les systèmes physiques ou logiques du
                propriétaire de l’Application Mobile, de ses fournisseurs, des autres
                Utilisateurs ou de tout tiers ;
            </li>
            <li>
                De soumettre au contenu pouvant constituer une infraction dite « de
                presse », relevant de la loi du 29 juillet 1881 sur la liberté́ de la
                presse ;
            </li>
            <li>
                De diffuser toute donnée, information ou contenu ayant un caractère
                diffamatoire, injurieux, obscène, raciste ou xénophobe, choquant,
                incitant à la haine ou la violence, menaçante, constitutive de
                harcèlement, et de manière générale tout contenu qui serait contraire
                aux lois et règlements en vigueur, aux bonnes mœurs, ou à l’ordre
                public.
            </li>
            <li>
                De porter atteinte de quelque façon que ce soit au droit au respect de
                la vie privée et au droit à l’image des autres Utilisateurs ou de tout
                tiers. Notamment, il est formellement interdit de diffuser des photos ou
                images faisant apparaitre de manière reconnaissable des tiers sans leur
                autorisation ou l’autorisation de leur représentant légal, sous peine de
                porter atteinte à leur droit à l’image ;
            </li>
            <li>
                De télécharger, envoyer, diffuser transmettre tout Contenu qui pourrait
                être constitutif de corruption de mineurs ;
            </li>
            <li>
                De télécharger, envoyer, diffuser transmettre tout Contenu qui pourrait
                être constitutif de fausse déclaration, d'atteinte à l'autorité́ de la
                Justice ou qui contiendrait des informations confidentielles ;
            </li>
            <li>
                De télécharger, envoyer, diffuser transmettre tout Contenu destiné à
                exhiber ou vendre des objets et/ou des ouvrages interdits ;
            </li>
            <li>
                D’emprunter une fausse identité́. L’Utilisateur ne doit pas se faire
                passer pour un autre Utilisateur, ou pour toute autre personne qu'il
                n'est pas, ou communiquer sous un faux nom, une fausse qualité́ ou un
                pseudonyme qu'il n'est pas autorisé́, ni habilité à utiliser, ni mentir
                sur sa qualité́ de majeur ou de mineur ;
            </li>
            <li>
                De télécharger, envoyer, diffuser transmettre tout Contenu violant tout
                brevet, marque déposée, secret de fabrication, droit d'auteur, droit de
                propriété́ intellectuelle ou tout autre droit de propriété́ appartenant à
                autrui ;
            </li>
            <li>
                De harceler, persécuter, embarrasser de quelque manière que ce soit un
                autre ou plusieurs autres Utilisateurs ou toute autre personne ;
            </li>
            <li>
                De solliciter l'échange, la vente ou l'achat d’éléments à caractère
                pornographique et/ou à caractère illégal, y compris, notamment, mais pas
                exclusivement, des photographies, des films, des vidéos, des
                enregistrements et des images, réalistes ou non ;
            </li>
            </ul>
            <p>
            Conformément à la loi sur l’Informatique et les libertés, l’Application
            Mobile permet aux Utilisateurs du Service, par l’intermédiaire du
            Formulaire de Contact dans la rubrique « Suggestions », ou directement via
            l’Application Mobile de porter à la connaissance de NSIA DIRECT tout
            comportement ou contenu qui lui semble illicite et/ou contraire aux
            présentes CGU notamment toutes données faisant l'apologie des crimes
            contre l'humanité́, incitant à la haine raciale ou la pornographie
            enfantine, incitant à la violence ou attentatoires à la dignité́ humaine,
            ainsi que contre les infractions visées par la loi sur la liberté́ de la
            presse, et aux articles du Code pénal.
            </p>
            <p>
            Ainsi, il est fortement recommandé aux Utilisateurs de suivre des règles
            simples de bonne conduite dans leurs échanges et éventuelles rencontres
            avec les autres Utilisateurs :
            </p>
            <ul>
            <li>Être respectueux, de bonne foi et honnête ;</li>
            </ul>
        </section>
        <section id="article_7">
            <h3>ARTICLE 7 : OBLIGATIONS DE NSIA DIRECT</h3>
            <p>NSIA DIRECT s'engage à fournir un Service conforme aux présentes CGU.</p>
            <p>
            NSIA DIRECT se réserve le droit de modifier toute information ou contenu
            figurant dans l’Application Mobile, à tout moment et sans préavis, dans le
            cadre de sa mise à jour ou de la correction d'erreurs ou d'inexactitudes
            ou si cela lui semble opportun sans que cela ouvre droit à une quelconque
            réparation pour les Utilisateurs.
            </p>
            <p>
            En cas de violation des présentes CGU ou des lois et règlements en
            vigueur, notamment en cas de manquement par un Utilisateur à l'une ou
            plusieurs des règles précitées à l’Article 6, ou dont le comportement
            pourrait compromettre ou risquer de compromettre le bon fonctionnement du
            Service ou porter atteinte aux droits des tiers ou à la réputation du
            Service, NSIA DIRECT se réserve le droit de suspendre et/ou de résilier
            unilatéralement l’exécution des présentes dans les conditions visées à
            l’Article 10 des présentes, et de bloquer et/ou supprimer le Compte
            personnel de l’Utilisateur concerné ainsi que son accès à tout ou partie
            du Service, de supprimer les contenus litigieux, de façon temporaire ou
            définitive, sans que cela ouvre droit pour l’Utilisateur à une quelconque
            indemnité́.
            </p>
            <p>
            En cas de soupçon ou de signalement par un Utilisateur d’un contenu
            illicite ou violant les présentes CGU, NSIA DIRECT se réserve le droit de
            suspendre le Compte personnel de l’Utilisateur concerné ou la publication
            du contenu litigieux dans un délai raisonnable dans le but de vérifier
            l’exactitude de l’information soupçonnée d’être abusive.
            </p>
            <p>
            Cependant, les Utilisateurs sont informés que tout signalement abusif peut
            être sanctionné conformément à la règlementation applicable et aux
            présentes CGU et peut entraîner la suspension et/ou la résiliation
            immédiate des présentes.Cependant, les Utilisateurs sont informés que tout
            signalement abusif peut être sanctionné conformément à la règlementation
            applicable et aux présentes CGU et peut entraîner la suspension et/ou la
            résiliation immédiate des présentes.
            </p>
        </section>
        <section id="article_8">
            <h3>ARTICLE 8 : LIMITATION DE RESPONSABILITÉS</h3>
            <p>
            À tout moment, NSIA DIRECT pourra modifier, interrompre temporairement ou
            définitivement l’accès au Service, et ce, sans avoir à en informer les
            internautes au préalable, NSIA DIRECT ne prenant aucun engagement de
            maintenir un accès permanent et ininterrompu à l’Application Mobile et/ou
            au Service. NSIA DIRECT n’est en aucun cas responsable de ces
            interruptions et des conséquences qui peuvent en découler pour
            l’Utilisateur.
            </p>
            <p>
            NSIA DIRECT ne sera pas responsable du fonctionnement inadéquat du Service
            s’il résulte d’opérations de maintenance, d’incidents, ou de problèmes
            liés à sa capacité́ à supporter les systèmes indispensables à l’utilisation
            du service, même si NSIA DIRECT fera ses meilleurs efforts pour assurer
            une réponse rapide, sans se responsabiliser pour les retards liés aux
            services de télécommunications. Notamment, NSIA DIRECT ne sera en aucun
            cas responsable du mauvais fonctionnement des opérateurs téléphoniques et
            des fournisseurs d’accès Internet auxquels l’Utilisateur aura eu recours,
            ni des plateformes de moyens de paiement que l’Utilisateur emploierait
            pour effectuer les paiements.
            </p>
            <p>
            L’Utilisateur reste seul responsable de tout usage qui pourrait être fait
            de ses identifiants et mot de passe, et de leur confidentialité́, ainsi que
            de toute utilisation de son Compte personnel. NSIA DIRECT ne pourra en
            aucun cas être tenue responsable de toute perte ou vol ou tout dommage
            résultant d’une utilisation frauduleuse des données d’identification des
            Utilisateurs.
            </p>
            <p>
            En tant que prestataire technique, NSIA DIRECT n’est pas tenue de vérifier
            la véracité́ des informations fournies par les Utilisateurs et décline
            toute responsabilité́ quant à l'inexactitude des données, informations et
            contenus diffusés par les Utilisateurs via l’Application Mobile, ou des
            erreurs ou omissions qu’ils pourraient comporter ainsi que tout dommage
            consécutif à l'utilisation de tout contenu fournit par un Utilisateur.
            </p>
            <p>
            NSIA DIRECT ne pourra en aucun cas être tenue responsable de toute
            conséquence qui pourrait survenir à l’occasion de rencontres ou prises de
            contact entre plusieurs Utilisateurs, suite à l'utilisation de
            l’Application Mobile.
            </p>
            <p>
            Le Service n’opère aucune sélection des Utilisateurs et n’intervient à
            aucun moment dans leur mise en relation. NSIA DIRECT n’est responsable ni
            des annonces et contenus publiés par les Utilisateurs, ni de
            l'organisation, ni du bon déroulement des rencontres et éventuelles
            transactions entre les Utilisateurs.
            </p>
            <p>
            NSIA DIRECT n’offre aucune garantie quant au fonctionnement et à la
            disponibilité́ dans l’accès à l’Application Mobile NSIA DIRECT en cas de
            survenance de cas de force majeure ou de cas fortuit tels que définis par
            la règlementation et la jurisprudence en vigueur.
            </p>
            <p>
            De façon expresse, sont considérées, notamment, mais pas exclusivement,
            comme cas de force majeure ou cas fortuits, outre ceux habituellement
            retenus par la jurisprudence des juridictions françaises : les intempéries
            exceptionnelles les grèves totales ou partielles, internes ou externes à
            l’entreprise, lock-out, épidémies, blocage des moyens de transports ou
            d’approvisionnement pour quelque raison que ce soit, tremblement de terre,
            incendies, tempêtes, inondations, dégâts des eaux, les catastrophes
            naturelles, la foudre, les attentats, les dommages provoqués par des virus
            pour lesquels les moyens de sécurité́ existant sur le marché ne permettent
            pas leur éradication, ainsi que toute obligation légale ou règlementaire
            ou d'ordre public imposée par les autorités compétentes et qui auraient
            pour effet de modifier substantiellement les présentes conditions
            générales, les pannes d’ordinateur, le blocage des télécommunications y
            compris le réseau P.T.T., la défaillance du réseau public des
            télécommunications, les pertes de connectivité Internet dues aux
            opérateurs publics ou privés, tout problème lié au modem ou au système
            informatique de l’Utilisateur ou son logiciel de navigation, les
            interconnexions de réseaux téléphoniques et/ou toute autre infrastructure
            de transport ou de télécommunications employée par l’utilisateur, la
            défaillance du réseau public de distribution d’électricité́ et tout autre
            évènement indépendant de la volonté́ expresse des parties empêchant
            l’exécution normale du Service.
            </p>
            <p>
            NSIA DIRECT n’est pas non plus responsable de la mauvaise configuration du
            terminal mobile de l’Utilisateur. Il appartient à chaque Utilisateur de
            s’assurer du bon fonctionnement et de la configuration de son matériel.
            </p>
            <p>
            NSIA DIRECT ne saurait engager sa responsabilité eu égard aux transactions
            éventuellement réalisées à titre privé ou professionnel entre les
            Utilisateurs eux-mêmes. Il est en effet rappelé aux Utilisateurs que NSIA
            DIRECT se limite via cette rubrique à offrir un accès à son Application
            Mobile à des annonceurs qui sont seuls responsables de la relation
            contractuelle ou délictuelle susceptible de naitre avec un Utilisateur
            suite à une visite d’un Utilisateur sur leur page et/ou à une transaction
            réalisée à cette occasion.
            </p>
        </section>
        <section id="article_9">
            <h3>ARTICLE 9 : DUREE</h3>
            <p>
            Dans le cas du téléchargement de l’Application Mobile gratuite, les
            présentes CGU sont souscrites pour une durée indéterminée à compter de
            leur acceptation par l’Utilisateur dans les conditions décrites à
            l’Article 1.
            </p>
        </section>
        <section id="article_10">
            <h3>ARTICLE 10 : RESILIATION</h3>
            <p>
            L'accès à l’Application Mobile et au Service pourrait être interrompu
            temporairement ou définitivement, notamment en cas de cessation par NSIA
            DIRECT de l'activité́ en cause, ou en cas de liquidation judiciaire ou
            amiable de la société́ NSIA Assurances. Les présentes CGU seraient alors
            résiliées de plein droit.
            </p>
            <p>
            En cas de décès de l’Utilisateur, les relations contractuelles entre
            celui-ci et NSIA DIRECT seront résiliées de plein droit et son Compte
            personnel sera désactivé́, sur production des pièces justificatives
            pertinentes des ayants droit. Son contenu ne pourra être transmis aux
            ayants droit que sur décision de Justice.
            </p>
            <p>
            En cas de violation des présentes par l’Utilisateur, ou des lois et
            règlements en vigueur, notamment, mais pas exclusivement, en cas de
            manquement par un Utilisateur à l'une ou plusieurs des règles précitées à
            l’Article 6, ou en cas de comportement compromettant ou risquant de
            compromettre le bon fonctionnement du Service ou porter atteinte aux
            droits des tiers ou à la réputation du Service, NSIA DIRECT se réserve le
            droit de suspendre et/ou de résilier unilatéralement l’exécution des
            présentes, et de bloquer et/ou supprimer le Compte personnel de
            l’Utilisateur concerné, ainsi que son accès à tout ou partie du Service,
            de supprimer les contenus litigieux, de façon temporaire ou définitive,
            sans que cela ouvre droit pour l’Utilisateur à une quelconque indemnité́,
            et sans préjudice de toute action en Justice que NSIA DIRECT pourrait
            intenter par la suite pour faire valoir ses droits.
            </p>
            <p>
            Tout Utilisateur peut se désinscrire à tout moment de l’Application Mobile
            en suivant la procédure suivante :
            </p>
            <ol>
            <li>
                Connexion à l’Application Mobile et saisie du login et mot de passe pour
                s’identifier;
            </li>
            <li>Clic sur l'onglet "Mon profil" ;</li>
            <li>
                Cocher la case « Désactiver mon profil », située au bas de la page
            </li>
            </ol>
        </section>
        <section id="article_11">
            <h3>ARTICLE 11 : PROPRIÉTÉ INTELLECTUELLE ET INDUSTRIELLE</h3>
            <h5>11.1 Titres de propriété́ intellectuelle de NSIA DIRECT</h5>
            <p>
            L’ensemble du contenu de l’Application Mobile et des Sites Web, les
            photographies, logos, images, sons, vidéo, graphiques, textes, ou
            illustrations ainsi que sa structure, les bases de données, logiciels,
            codes ainsi que tout autre matériel et élément visuel composant
            l’Application Mobile est protégé, notamment par le droit de la propriété́
            intellectuelle dont NSIA DIRECT reste le seul titulaire.
            </p>
            <p>
            Les présentes CGU n’emportent aucune cession d’aucune sorte de droits de
            propriété́ intellectuelle sur les éléments appartenant à NSIA DIRECT et/ou
            à ses partenaires au bénéfice de l’Utilisateur.
            </p>
            <p>
            Les Utilisateurs s’engagent à respecter les droits de propriété́
            intellectuelle attachés aux éléments composants l’Application Mobile et
            s’interdisent, notamment de les diffuser, publier, transmettre, céder à
            tout tiers, de les exploiter à des fins commerciales, de les reproduire,
            les copier ou les modifier sans autorisation expresse de NSIA DIRECT.
            Notamment, toute extraction ou réutilisation des données contenues dans
            l’Application Mobile, au-delà de son usage normal est strictement
            interdite à tout Utilisateur et est soumise à l'autorisation expresse et
            préalable de NSIA DIRECT.
            </p>
            <h5>11.2 Droit d’usage de l’Application Mobile par l’Utilisateur</h5>
            <p>
            L’Utilisateur ne dispose que d'un droit d'usage strictement personnel, non
            exclusif et non transférable de l’Application Mobile. Tout autre usage est
            soumis à l’autorisation préalable et expresse de NSIA DIRECT.
            </p>
            <p>
            Toute reproduction, représentation ou diffusion, y compris l’addition à
            celle-ci de nouvelles fonctions ou la réalisation de modifications sur
            celle-ci qui altéreraient son fonctionnement, par quelque moyen que ce
            soit et sur quelque support que ce soit, est formellement interdite, à la
            seule exception du droit de reproduire pour stockage aux fins de
            représentation pour copie de sauvegarde ou impression sur support papier
            en un exemplaire, sous condition du respect de l'intégrité́ des documents.
            </p>
            <p>
            Le droit d’utilisation de l’Application Mobile accordée en vertu des
            présentes CGU pourra être résilié à tout moment par l’Utilisateur par la
            désinstallation de l’Application et l’élimination de l’ensemble des copies
            de l’Application Mobile sur ses appareils ou par la résiliation des
            présentes selon les termes de l’article 11.
            </p>
            <h5>
            11.3 Licence d'utilisation des contenus mis en ligne par les Utilisateurs
            </h5>
            <p>
            Concernant le contenu et les informations protégés par des droits de
            propriété́ intellectuelle, tels que les photos, textes ou vidéos que les
            Utilisateurs mettent en ligne via sur l’Application Mobile NSIA DIRECT,
            les Utilisateurs accordent une licence non exclusive, transférable,
            sous-licenciable, sans redevance et mondiale pour l’utilisation de ces
            contenus de propriété́ intellectuelle publiés via l’Application Mobile ou
            en relation avec l’Application Mobile dès leur mise en ligne (licence de
            propriété́ intellectuelle).
            </p>
            <p>
            Cette licence est consentie pour le monde entier et pour toute la durée de
            protection des droits de propriété́ intellectuelle des données et contenus
            en question.
            </p>
            <p>
            Cette licence de propriété́ intellectuelle se termine lorsque les
            Utilisateurs suppriment leurs contenus de propriété́ intellectuelle ou leur
            compte.
            </p>
            <p>
            L'Utilisateur est seul responsable du contenu publié et partagé par lui
            via l’Application Mobile.
            </p>
            <p>
            Ainsi, l’Utilisateur garantit NSIA DIRECT que les données et contenus
            transmis par lui via l’Application Mobile ne portent pas atteinte aux
            droits de propriété intellectuelle ou droit à l’image de tiers et garantit
            NSIA DIRECT contre toute action en Justice que pourraient intenter des
            tiers en revendication de leurs droits de propriété́ intellectuelle sur les
            données et contenus transmis via l’Application Mobile.
            </p>
        </section>
        <section id="article_12">
            <h3>ARTICLE 12 : POLITIQUE DE CONFIDENTIALITÉ ET DONNÉES PERSONNELLES</h3>
            <h5>12.1 Généralités</h5>
            <p>
            Dans le cadre de l’exécution de ses prestations, NSIA DIRECT est
            susceptible de collecter des données personnelles relatives notamment à la
            population de personnes physiques objet des prestations commandées par les
            Utilisateurs.
            </p>
            <p>
            Conformément aux dispositions de la loi, relative à l’informatique, aux
            fichiers et aux libertés Informatique et Libertés, le traitement
            automatisé des données nominatives réalisées à partir de l’Application
            Mobile et des Sites Web a fait l'objet d'une déclaration auprès de la
            Commission Nationale de l'Informatique et des Libertés (CNIL)
            </p>
            <p>
            En application de la loi relative à la protection des personnes physiques
            à l’égard du traitement des données à caractère personnel et à la libre
            circulation de ces données, les données personnelles qui seront conservées
            au sein de ce fichier automatisé qui se trouve sous la responsabilité de
            NSIA DIRECT, seront utilisées avec pour seule finalité de permettre la
            fourniture et la bonne exécution des services proposés.
            </p>
            <p>
            La collecte des données personnelles recueillies par le biais du Service
            NSIA DIRECT est nécessaire au bon fonctionnement du Service et est
            obligatoire pour accéder aux services proposés via l’Application Mobile.
            </p>
            <p>
            Le défaut de communication des données personnelles obligatoires empêche
            l’accès au Service proposé par NSIA DIRECT.
            </p>
            <p>
            NSIA DIRECT réalise la conservation des Données Personnelles de façon à
            permettre le respect de leur intégrité durant le temps nécessaire à la
            réalisation et la fourniture du Service proposé et conformément aux durées
            de conservation imposées par la législation en vigueur.
            </p>
            <h5>12.2 Obligations de NSIA DIRECT dans le cadre de la législation :</h5>
            <p>
            NSIA DIRECT s’engage à traiter lesdites données personnelles dans le
            respect de cette règlementation, et à cet égard, s’engage à :
            </p>
            <ul>
            <li>
                Ne collecter et traiter les données personnelles que conformément aux
                instructions expresses de l’Utilisateur et aux finalités liées à l’objet
                des services proposés via l’Application Mobile.
            </li>
            <li>
                Préserver la sécurité, l’intégrité et la confidentialité des données
                personnelles dès lors qu’il procède à leur collecte ou leur
                enregistrement dans le cadre de l’exécution des Services ;
            </li>
            <li>
                Ne communiquer les données personnelles à aucun tiers quel qu’il soit,
                hormis les tiers auxquels il est strictement nécessaire de transmettre
                les données personnelles en exécution des prestations proposées ; Les
                données personnelles ainsi collectées pourront ainsi être transmises au
                Personnel de NSIA DIRECT ainsi qu’à tout tiers chargé de participer à la
                mise en place, à la réalisation ou au suivi du Service (personnel,
                partenaires et/ou sous-traitants). Les membres du Personnel de NSIA
                DIRECT ainsi que les tiers désignés par ce dernier, auront accès et
                pourront utiliser les données personnelles collectées dans le seul but
                de fournir le Service proposé.
                <br />
                En aucun cas, les données personnelles ne seront cédées à d’autres
                tiers, que ce soit à titre gracieux ou onéreux, sans l’autorisation de
                l’Utilisateur, à l’exception des cas prévus à l’article 10 des présentes
                qui prévoit que les données permettant l’identification de l’Utilisateur
                pourront être transmises aux ayants droit sur décision de Justice.
            </li>
            <li>
                N’effectuer aucun transfert de données personnelles en dehors du
                territoire de l’Union européenne, hormis vers des pays tiers présentant
                un niveau de protection adéquat au sens des autorités de contrôle ou
                vers un sous-traitant autorisé par l’Utilisateur et signataire des
                clauses contractuelles types édictées par les autorités européennes ;
            </li>
            <li>
                Mettre en place tout système de sécurisation des données qui serait
                requis soit en raison d’une analyse d’impact menée par l’Utilisateur en
                tant que responsable du traitement soit en raison d’une législation
                spécifique imposant de recourir à des modalités déterminées de
                conservation des données ;
            </li>
            <li>
                Alerter sans délai l’Utilisateur en cas de violation, de perte ou de
                divulgation non autorisée de données personnelles collectées dans le
                cadre de l’utilisation des Services, afin de permettre à l’Utilisateur
                d’alerter les personnes concernées et de se conformer à ses obligations
                au sens de la règlementation susmentionnée.
            </li>
            </ul>
            <p>
            NSIA DIRECT s’abstient en toute hypothèse de reproduire, exploiter ou
            utiliser les données personnelles collectées à l’occasion de ses
            prestations ses propres fins ou pour le compte de tiers, et s’engage à
            modifier ou supprimer, soit à la demande de l’Utilisateur, soit à la
            demande d’une personne concernée, et en toute hypothèse à l’achèvement de
            la finalité poursuivie et au terme de l’exécution de ses prestations,
            toute donnée personnelle collectée à l’occasion ou aux fins d’exécution
            desdites prestations.
            </p>
            <p>
            Tout Utilisateur peut envoyer une plainte au sujet du respect de la vie
            privée ou toute question au sujet des informations recueillies et traitées
            par NSIA DIRECT à l’adresse électronique suivante :
            <a href="mailto:ecoute.togo@groupensia.com">ecoute.togo@groupensia.com</a>
            </p>
            <h5>12.3 Nature des informations collectées</h5>
            <p>
            Lors de la souscription et l’utilisation du Service, NSIA DIRECT ne
            recueille et conserve que certaines informations, à savoir : Prénom, Nom
            de Famille, Code postal, Email, mot de passe choisi, numéro de téléphone,
            </p>
            <p>
            Si l’Utilisateur s’est identifié via son profil Facebook, alors NSIA
            DIRECT pourra avoir accès à son identifiant et à son profil.
            </p>
            <h5>
            12.4 Droit d’accès, de rectification et de suppression des données
            personnelles
            </h5>
            <p>
            Tout Utilisateur a le droit d’accéder, de rectifier ou de s’opposer au
            traitement de toute donnée le concernant qui ne soit pas indispensable à
            la finalité du recueil.
            </p>
            <p>
            Conformément aux articles de la loi relative à l’informatique, aux
            fichiers et aux libertés, et à la protection des personnes physiques à
            l’égard du traitement des données à caractère personnel et à la libre
            circulation de ces données, toute personne peut obtenir communication et,
            le cas échéant, rectification ou suppression des informations la
            concernant, en adressant un courrier électronique à l’adresse de contact
            <a href="mailto:ecoute.togo@groupensia.com">ecoute.togo@groupensia.com</a>
            </p>
            <p>
            A cet effet, au sein des registres informatiques de NSIA DIRECT peuvent
            être conservés les noms ou prénom, l’adresse email, le mot de passe,
            l’adresse IP de l’Utilisateur, la marque et le modèle de l’appareil,
            l’opérateur mobile, la date et l’heure exacte de publication des
            informations et contenus transmises via l’Application Mobile.
            </p>
            <h5>12.5 Utilisation des cookies, identifiants et du fichier d’activité</h5>
            <p>
            Afin d’améliorer le Service NSIA DIRECT en termes de rendement du système
            et de facilité d’usage, ainsi que pour proposer de l’information utile sur
            les produits et services, peuvent être recueillies automatiquement et
            conservées des informations dans les fichiers de registre (log files) en
            provenance des ordinateurs ou terminaux utilisés.
            </p>
            <p>
            Ceci inclut des données non personnelles telles que l’adresse IP, le type
            de navigateur, langue sélectionnée, le système d’exploitation, le
            fournisseur d’accès Internet (ISP) ainsi que la date et l’heure. Ces
            informations sont utilisées de façon globale pour améliorer la gestion de
            l’Application Mobile, analyser les tendances et recueillir des données
            démographiques sur les Utilisateurs.
            </p>
            <p>
            Si des informations non personnelles sont utilisées en combinaison avec
            les Données Personnelles, l’ensemble sera traité en tant que Données
            Personnelles et sera dès lors traité conformément au présent article 12.
            </p>
            <p>
            De même, dans le but d’optimiser les services de NSIA DIRECT, les messages
            envoyés par courrier électronique, les services onlines, les publicités et
            les applications interactives peuvent utiliser les “cookies” ou les
            “identifiants anonymes” des utilisateurs (en ce qui concerne les Sites
            web).
            </p>
            <h6>Que sont les cookies ?</h6>
            <p>
            Un cookie est un petit fichier, habituellement formé par des lettres et
            des nombres, envoyés par notre serveur web ou par l’Application Mobile à
            un fichier de cookies du navigateur de l’Utilisateur. Ceci permet à NSIA
            DIRECT de se souvenir de la présence d’un Utilisateur lors de
            l’établissement d’une nouvelle connexion entre au serveur de NSIA DIRECT
            et le navigateur de l’Utilisateur. Le principal objectif d’un cookie est
            de permettre au serveur de NSIA DIRECT de présenter des pages web
            personnalisées qui puissent faire de la consultation du Service une
            expérience individuelle et ajustée aux préférences personnelles.
            </p>
            <h6>Que sont les identifiants ou sondes ?</h6>
            <p>
            Un identifiant anonyme est une chaîne de caractères aléatoires qui
            s’utilise avec la même finalité́ que les cookies sur des plateformes sur
            lesquelles la technologie des cookies est indisponible, ceci inclut
            certains types d’appareils mobiles ainsi que les applications installées.
            </p>
            <h5>12.6 Obligations de l’Utilisateur</h5>
            <p>
            Il est rappelé qu’il appartient à l’Utilisateur, de recueillir tout
            consentement nécessaire auprès des personnes physiques concernées, en
            corrélation avec les commentaires et publications de toute nature qu’il
            dispense sur l’’application.
            </p>
            <p>
            En outre, les personnes concernées par les publications ou commentaires
            d’un Utilisateur disposent sur les données personnelles les concernant des
            droits d’accès, de rectification, d’effacement, de limitation, de
            portabilité et d’opposition, et peuvent à tout moment révoquer les
            consentements aux traitements. Les personnes concernées seront
            susceptibles de faire valoir leurs droits directement auprès des
            Utilisateurs, qui s’engagent le cas échéant à les transmettre à NSIA
            DIRECT afin que ces demandes soient traitées dans les meilleurs délais,
            par envoi d’un courriel à l’adresse électronique suivante :
            ecoute.togo@groupensia.com
            </p>
        </section>
        <section id="article_13">
            <h3>ARTICLE 13 : LÉGISLATION APPLICABLE – LITIGES - LANGUE</h3>
            <p>
            La conclusion, l'interprétation et la validité́ des présentes CGU et
            l’ensemble des contrats qui en découlent et leurs suites sont soumis à la
            Loi et la Règlementation en vigueur, à l'exclusion de toute autre
            législation, quelle que soit la nationalité́ de l’Utilisateur, il en est
            ainsi pour les règles de fond et de formes.
            </p>
            <p>
            À défaut d’accord amiable entre les parties et en cas d'échec des
            pourparlers, les parties reprendront leur entière liberté́ et leur litige
            sera porté devant la Cour d’Arbitrage du Togo.
            </p>
            <p>
            Notamment, en application du règlement en ligne des litiges de
            consommation, le Client est informé que tout litige issu des présentes
            conditions générales pourra être porté devant la plate-forme de règlement
            en ligne des litiges.
            </p>
            <p>
            De convention expresse, à défaut d’accord amiable, les juridictions du
            ressort du siège social de NSIA DIRECT seront seules compétentes pour tout
            litige ou contestation se rapportant notamment, mais pas exclusivement à
            la formation, l’interprétation, à l’exécution, ou à l’inexécution,
            résiliation des présentes, nonobstant pluralité́ de défendeurs ou appel en
            garantie, même pour les procédures conservatoires, en référé́ ou par
            requête.
            </p>
            <p>
            En cas de difficulté́ d'interprétation, la version en langue française des
            présentes CGU prévaut sur toute autre version qui serait traduite dans une
            autre langue.
            </p>
        </section>
        <section id="article_14">
            <h3>ARTICLE 14 : ANNULATION ET INEFFICACITÉ DES CLAUSES</h3>
            <p>
            La nullité́ ou l’impossibilité́ de mise en œuvre de l’une des quelconques
            clauses des présentes CGU, si elle ne remet pas en cause notablement
            l’équilibre contractuel, n’affectera que la clause concernée et
            n’entraînera pas l’annulation des présentes CGU.
            </p>
            <p>
            L’Utilisateur s’engage à lire attentivement le contenu du présent document
            qui inclut les Conditions Générales d’Utilisation du Service, et accepte
            expressément et sans réserve toutes les règles et obligations qui y sont
            exposées.
            </p>
        </section>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    #step{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        margin-top: 20px;
        margin-left: 150px;
        margin-right: 150px;
        text-justify: distribute;
    }
    h3{
        margin-bottom: 20px;
    }
</style>
